import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "header block" }
const _hoisted_3 = { class: "enterprise-basic" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "detail-value" }
const _hoisted_6 = { class: "detail-value" }
const _hoisted_7 = { class: "search" }
const _hoisted_8 = { class: "block" }
const _hoisted_9 = { class: "table" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "row place-row" }
const _hoisted_12 = { class: "row place-row" }

import alertBox from '@/components/alert-box.vue'

import { defineComponent } from 'vue'
import { getEnterpriseProject, placeProject } from '@/api/project'
import { ProjectDto } from '@/api/dto'
import { exportProjectWorkers } from '@/api/export'

const __default__ = defineComponent({
    name: 'EnterpriseDetail',
    data () {
        return {
            tableData: [] as ProjectDto[],
            pageNum: 1,
            pageSize: 10,
            total: 0,
            searchText: '',
            searchValue: '',
            selects: [] as string[],
            serveCompanyName: '',
            progressCount: 0,
            ppCount: 0,
            placeType: '',
            placeRemark: '',
            placeIds: ''
        }
    },
    created () {
        this.handleCurrentChange()
    },
    methods: {
        async handleCurrentChange () {
            const result = await getEnterpriseProject({
                pageNum: this.pageNum,
                pageSize: this.pageSize,
                serveCompanyId: Number(this.$route.params.id) as number,
                searchText: this.searchValue
            })
            this.tableData = result.list
            this.total = result.totalCount
            this.serveCompanyName = result.serveCompanyName
            this.progressCount = result.progressCount
            this.ppCount = result.ppCount
        },
        handleSizeChange () {
            this.pageNum = 1
            this.handleCurrentChange()
        },
        search () {
            this.searchValue = this.searchText
            this.pageNum = 1
            this.handleCurrentChange()
        },
        onReset () {
            this.searchText = ''
            this.search()
        },
        async onExport () {
            const result = await exportProjectWorkers({
                ids: this.selects.join(','),
                serveCompanyId: this.$route.params.id as string
            })
            window.location.href =
                process.env.VUE_APP_BASE_URL +
                    '/common/download?delete=true&fileName=' +
                    result

            this.$message.success('导出成功！')
        },
        handleSelectionChange (selects: { id: string }[]) {
            this.selects = selects.map(item => item.id)
        },
        onPlace () {
            this.placeIds = this.selects.join(',')
            if (!this.placeIds) {
                this.$message.error('请至少选择一个项目归档')
            }
        },
        async onPlaceSubmit () {
            if (!this.placeType) {
                this.$message.error('请选择归档标识')
                return
            }
            if (!this.placeRemark) {
                this.$message.error('请输入归档原因')
                return
            }
            await placeProject({
                archivedIds: this.selects,
                isArchived: 1,
                archivedRemark: this.placeType + '：' + this.placeRemark
            })
            this.$message.success('归档成功！')
            this.placeIds = ''
            this.handleCurrentChange()
        }
    }
})


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_export_button = _resolveComponent("export-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, "派遣单位名称：" + _toDisplayString(_ctx.serveCompanyName), 1),
          _createElementVNode("div", null, [
            _cache[13] || (_cache[13] = _createElementVNode("span", { class: "detail-key" }, "项目数：", -1)),
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.ppCount), 1),
            _cache[14] || (_cache[14] = _createElementVNode("span", { class: "detail-key" }, "进行中：", -1)),
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.progressCount), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            placeholder: "请输入人员名称/项目名称",
            class: "input search-input",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchText) = $event)),
            onKeydown: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)), ["enter"]))
          }, null, 544), [
            [_vModelText, _ctx.searchText]
          ]),
          _createElementVNode("button", {
            class: "btn",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)))
          }, "搜索"),
          _createElementVNode("button", {
            class: "btn-white",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onReset && _ctx.onReset(...args)))
          }, "重置"),
          _createVNode(_component_export_button, {
            style: {"width":"initial"},
            onExport: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onExport()))
          }, {
            default: _withCtx(() => _cache[15] || (_cache[15] = [
              _createTextVNode("导出表格")
            ])),
            _: 1
          }),
          _createElementVNode("button", {
            class: "btn-green",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onPlace()))
          }, _cache[16] || (_cache[16] = [
            _createElementVNode("i", { class: "el-icon el-icon-folder-add" }, null, -1),
            _createElementVNode("text", null, "归档", -1)
          ]))
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_el_table, {
            data: _ctx.tableData,
            style: {"width":"100%"},
            "header-row-style": { color: '#202536' },
            "row-style": { color: '#5E617D' },
            onSelectionChange: _ctx.handleSelectionChange
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, { type: "selection" }),
              _createVNode(_component_el_table_column, {
                prop: "projectName",
                label: "项目名"
              }),
              _createVNode(_component_el_table_column, {
                prop: "contacts",
                label: "负责人"
              }),
              _createVNode(_component_el_table_column, {
                prop: "pwCount",
                label: "总人数"
              }),
              _createVNode(_component_el_table_column, {
                prop: "createTime",
                label: "创建时间"
              }),
              _createVNode(_component_el_table_column, { label: "操作" }, {
                default: _withCtx((scope) => [
                  _createElementVNode("p", {
                    class: "link",
                    onClick: ($event: any) => (
                                    _ctx.$router.push({
                                        path: '/project/make/' + scope.row.id
                                    })
                                )
                  }, " 查看详情 ", 8, _hoisted_10)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data", "onSelectionChange"]),
          _createVNode(_component_el_pagination, {
            class: "pagination",
            currentPage: _ctx.pageNum,
            "onUpdate:currentPage": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.pageNum) = $event)),
            "page-size": _ctx.pageSize,
            "onUpdate:pageSize": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.pageSize) = $event)),
            "page-sizes": [10, 30, 50, 100],
            layout: "total, sizes, prev, pager, next, jumper",
            total: _ctx.total,
            onSizeChange: _ctx.handleSizeChange,
            onCurrentChange: _ctx.handleCurrentChange
          }, null, 8, ["currentPage", "page-size", "total", "onSizeChange", "onCurrentChange"])
        ])
      ])
    ]),
    (_ctx.placeIds)
      ? (_openBlock(), _createBlock(alertBox, {
          key: 0,
          class: "place-box",
          "data-title": "创建项目归档",
          onClose: _cache[12] || (_cache[12] = ($event: any) => (_ctx.placeIds = ''))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, [
              _cache[19] || (_cache[19] = _createElementVNode("div", { class: "text" }, [
                _createElementVNode("span", { class: "important" }, "*"),
                _createTextVNode("项目标签")
              ], -1)),
              _createElementVNode("div", null, [
                _createVNode(_component_el_radio, {
                  modelValue: _ctx.placeType,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.placeType) = $event)),
                  label: "重复创建"
                }, {
                  default: _withCtx(() => _cache[17] || (_cache[17] = [
                    _createTextVNode("重复创建")
                  ])),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_radio, {
                  modelValue: _ctx.placeType,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.placeType) = $event)),
                  label: "项目结束"
                }, {
                  default: _withCtx(() => _cache[18] || (_cache[18] = [
                    _createTextVNode("项目结束")
                  ])),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _cache[20] || (_cache[20] = _createElementVNode("div", { class: "text" }, [
                _createElementVNode("span", { class: "important" }, "*"),
                _createTextVNode("备注")
              ], -1)),
              _createVNode(_component_el_input, {
                type: "textarea",
                class: "textarea",
                modelValue: _ctx.placeRemark,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.placeRemark) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("button", {
              class: "btn mini-btn",
              onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.onPlaceSubmit && _ctx.onPlaceSubmit(...args)))
            }, "提交归档")
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})